
<div class="gutter">
  <div class="flx-col">
    <header #header class="flx-col flx-gap-default">
      <h1 #headerTitle *ngIf="pageTitle">{{ pageTitle }}</h1>
      <div *ngIf="pageContent">
        <app-ve [content]="pageContent"></app-ve>
      </div>
    </header>    

    <nav mat-tab-nav-bar>
      <a *appShowB2b="'module_orders'" mat-tab-link [routerLink]="['/'+path_account_orders]" routerLinkActive #rla4="routerLinkActive" [active]="rla4.isActive"> 
        <span i18n="@@uorders">Zamówienia</span>
      </a>
      <!-- <a *appShowB2b="'module_discounts'" mat-tab-link [routerLink]="['/'+path_account_discounts]" routerLinkActive #rla3="routerLinkActive" [active]="rla3.isActive"> 
        <span i18n="@@udiscounts">Rabaty</span>
      </a> -->
      <!-- <a *appShowB2b="'module_bonuses'" mat-tab-link [routerLink]="['/'+path_account_bonuses]" routerLinkActive #rla10="routerLinkActive" [active]="rla10.isActive"> 
        <span i18n="@@ubonuses">Bonusy</span>
      </a> -->
      <a *appShowB2b="'module_invoices'" mat-tab-link [routerLink]="['/'+path_account_invoices]" routerLinkActive #rla6="routerLinkActive" [active]="rla6.isActive"> 
        <span i18n="@@ufvs">Faktury</span>
      </a>
      <a *appShowB2b="'fitter'" mat-tab-link [routerLink]="['/'+path_account_evidence]" routerLinkActive #rla9="routerLinkActive" [active]="rla9.isActive"> 
        <span i18n="@@uewd">Ewidencja montażu</span>
      </a>
      <a *appShowB2b="'module_returns'" mat-tab-link [routerLink]="['/'+path_account_returns]" routerLinkActive #rla5="routerLinkActive" [active]="rla5.isActive"> 
        <span i18n="@@ucompl">Reklamacje</span>
      </a>
      <a *appShowB2b="'module_contacts'" mat-tab-link [routerLink]="['/'+path_account_contacts]" routerLinkActive #rla12="routerLinkActive" [active]="rla12.isActive">
        <span i18n="@@ucontacts">Kontakty</span>
      </a>
      <a *appShowB2b="'module_files'" mat-tab-link [routerLink]="['/'+path_account_files]" routerLinkActive #rla7="routerLinkActive" [active]="rla7.isActive">
        <span i18n="@@ufiles">Pliki</span>
      </a>
      <a *appShowB2b="'module_files'" mat-tab-link [routerLink]="['/'+path_account_warranties]" routerLinkActive #rla11="routerLinkActive" [active]="rla11.isActive">
        <span i18n="@@uwarranties">Gwarancje</span>
      </a>
      <a *appShowB2b="'module_users'" mat-tab-link [routerLink]="['/'+path_account_users]" routerLinkActive #rla8="routerLinkActive" [active]="rla8.isActive">
        <span i18n="@@uemploye">Pracownicy</span>
      </a>
      <a mat-tab-link [routerLink]="['/'+path_account_profile]" routerLinkActive #rla1="routerLinkActive" [active]="rla1.isActive">
        <span i18n="@@uprofile">Dane adresowe</span>
      </a>
      <a mat-tab-link [routerLink]="['/'+path_account_password]" routerLinkActive #rla10="routerLinkActive" [active]="rla10.isActive">
        <span i18n="@@upass">Zmiana hasła</span>
      </a>
      <a mat-tab-link [routerLink]="['/'+path_logout]">
        <span class="red" i18n="@@ulogout">Wyloguj</span>
      </a>
    </nav>
    <router-outlet></router-outlet>
  </div>
</div>